<template>
  <section class="form-list">
    <el-form
      ref="form"
      :rules="rules"
      :model="post"
      label-position="right"
      label-width="130px"
      class="form"
    >
      <el-form-item label="套餐名称" prop="card_charge_type_name">
        <el-input
          v-model="post.card_charge_type_name"
          maxlength="14"
          show-word-limit
          clearable
          placeholder="请输入套餐名称"
        />
      </el-form-item>
      <el-form-item label="课程类型" prop="card_type_id">
        <v-select-card-type-id
          class="w100"
          v-model="post.card_type_id"
        />
      </el-form-item>
      <el-form-item label="可办门店" prop="stores">
        <v-cascader-store
          class="w100"
          placeholder="请选择可以办理此课卡的门店"
          :multiple="true"
          v-model="post.stores"
          @change="data => Object.assign(post, data)"
        />
      </el-form-item>

      <el-form-item label="套餐价格" prop="price">
        <v-input-money
          class="w100"
          placeholder="请输入套餐价格"
          :is-show-suffix="true"
          v-model="post.price"
        />
      </el-form-item>

      <el-form-item label="价格备注" prop="price_name">
        <el-input
          v-model="post.price_name"
          maxlength="32"
          show-word-limit
          clearable
          placeholder="办理课卡时将展示价格备注"
        />
      </el-form-item>

      <el-form-item
        label="有效天数"
        prop="expire_days"
      >
        <v-input-number
          class="w100"
          placeholder="开卡后系统将根据有效天数自动计算出失效日期"
          v-model="post.expire_days"
          type="unsignedSmallInt"
        />
      </el-form-item>
      <el-form-item
        label="停卡时长"
        prop="stop_days"
      >
        <v-input-number
          class="w100"
          placeholder="0 = 该套餐不支持停卡；非 0 时填 0.5 ~ 365 天"
          v-model="post.stop_days"
          type="unsignedSmallInt"
          :min="0"
          :max="365"
          :precision="2"
          :is-show-suffix="true"
          suffix-name="天"
          @input="handleStopDaysInput"
        />
        <el-alert
          title="0 表示该套餐不支持停卡；非 0 时请填 0.5 ~ 365 天，支持两位小数。"
          type="info"
          show-icon
          :closable="false"
        />
      </el-form-item>
      <el-form-item label="计费类型">
        <el-radio v-model="post.is_number_limit" :label="1">次卡</el-radio>
        <el-radio v-model="post.is_number_limit" :label="0">期限卡</el-radio>
      </el-form-item>
      <el-form-item
        v-if="post.is_number_limit"
        label="有效次数"
        prop="expire_number"
      >
        <v-input-money
          class="w100"
          placeholder="每次预约会扣除相应的有效次数"
          :is-show-suffix="true"
          suffix-name="次"
          v-model="post.expire_number"
        />
      </el-form-item>
      <el-form-item v-else label="有效次数">
        <span class="success-color">无限制</span>
      </el-form-item>

      <el-form-item label="仅限新生办理">
        <el-switch v-model="post.is_new" :active-value="1" :inactive-value="0"/>

        <el-alert
          title="此功能默认关闭，所有学员皆可办理"
          type="info"
          show-icon
          :closable="false"
        />
      </el-form-item>

      <el-form-item label="禁止预约专栏">
        <el-switch v-model="post.is_disable_column" :active-value="1" :inactive-value="0"/>

        <el-alert
          title="此功能默认关闭，所有学员皆可预约专栏"
          type="info"
          show-icon
          :closable="false"
        />
      </el-form-item>

      <el-form-item label="赠送课次券" prop="card_ticket_type_id">
        <v-select-card-ticket-type
          class="w100"
          v-model="post.card_ticket_type_id"
          @change="handleCardTicketTypeChange"
        />
        <el-alert
          v-if="cardTicketIsNew && !post.is_new"
          title="该课次券仅限新生办理，请选择其他课次券"
          type="error"
          show-icon
          :closable="false"
        />
        <el-alert
          v-else
          title="选择课次券后，办理本课卡时为学员赠送对应课次券"
          type="info"
          show-icon
          :closable="false"
        />
      </el-form-item>

      <el-form-item>
        <el-button type="primary" @click="handleSubmit" :loading="isSaving">立即添加</el-button>
        <el-button @click="RouteConfig.cardChargeTypeList.back">取消</el-button>
      </el-form-item>
    </el-form>
  </section>
</template>

<script>
import RouteConfig from '@/router/config';
import { store } from '@/api/card-charge-type';
import { toCent } from "@/filters";

export default {
  name: RouteConfig.cardChargeTypeAdd.name,
  data: () => ({
    RouteConfig,
    isSaving: false,
    isPhoneSearching: false,
    isCardNumberSearching: false,
    cardTicketIsNew: false,
    post: {
      card_charge_type_name: '',
      expire_days: 0,
      stop_days: 0,
      expire_number: '',
      stores: [],
      store_ids: [],
      card_type_id: 0,
      price: 0,
      price_name: '',
      is_all: 0,
      is_number_limit: 1,
      is_new: 0,
      is_disable_column: 0,
    },
    pickerOptions: {
      disabledDate: (time) => time.getTime() < 0,
    },
    rules: {
      card_charge_type_name: [{ required: true, message: '请输入套餐名称', trigger: 'change' }],
      card_type_id: [{ required: true, message: '请选择课程类型', trigger: 'change' }],
      stores: [{ required: true, message: '请选择可用门店', trigger: 'change' }],
      price: [{ required: true, message: '请输入套餐价格', trigger: 'change' }],
      price_name: [{ required: true, message: '请输入套餐价格备注', trigger: 'change' }],
      expire_number: [{ required: true, message: '请输入套餐有效次数', trigger: 'change' }],
      stop_days: [{
        validator: (rule, value, callback) => {
          const days = Number(value);
          if (days === 0 || (days >= 0.5 && days <= 365)) return callback();
          callback(new Error('停卡时长需为 0（不支持停卡）或 0.5 ~ 365 天'));
        },
        trigger: 'change',
      }],
    },
  }),
  methods: {
    handleCardTicketTypeChange(cardTicketType) {
      this.cardTicketIsNew = cardTicketType.is_new;
    },
    // 输入过程中即校验停卡时长范围（自定义输入组件仅失焦时钳制，避免快节奏提交时看不到修正）
    handleStopDaysInput() {
      this.$refs.form && this.$refs.form.validateField('stop_days');
    },
    handleSubmit() {
      if (this.isSaving) return;

      this.$refs.form.validate(async (isSuccess) => {
        if (!isSuccess) return;

        this.isSaving = true;
        const postData = { ...this.post };
        const { isError } = await store({
          card_charge_type_name: postData.card_charge_type_name,
          card_type_id: postData.card_type_id,
          expire_days: postData.expire_days,
          stop_days: toCent(postData.stop_days),
          is_number_limit: postData.is_number_limit,
          expire_number: postData.is_number_limit ? toCent(postData.expire_number) : 0,
          price: toCent(postData.price),
          store_ids: postData.store_ids,
          is_all: postData.is_all,
          price_name: postData.price_name,
          is_new: postData.is_new,
          is_disable_column: postData.is_disable_column,
          card_ticket_type_id: postData.card_ticket_type_id,
        });
        this.isSaving = false;
        if (!isError) RouteConfig.cardChargeTypeList.push();
      });
    },
  },
};
</script>
